import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import useAuthService from '../../services/auth/authService';
import useLayoutService from '../../services/layout/layoutService';
import classes from './AdminGateLayout.module.css';

export default function AdminGateLayout() {
  const authService = useAuthService();
  const { isAuth, isAdmin } = useSelector((s) => s.auth);
  const { texts } = useSelector((s) => s.translate);
  useLayoutService();

  useEffect(() => {
    authService.auth();
  }, []);

  useEffect(() => {
    if (isAuth !== false || window.config?.autoLogin !== true) return;
    authService.accessRequest();
  }, [isAuth]);

  if (!isAuth) {
    return (
      <div className={classes.shell}>
        <div className={classes.center}>
          <div className={classes.cookieText}>
            {texts.nonAuthText}
          </div>
          <button type="button" className={classes.cookieButton} onClick={() => authService.accessRequest()}>
            {texts.grantPermission}
          </button>
        </div>
      </div>
    );
  }

  if (!isAdmin) {
    return (
      <div className={classes.shell}>
        <div className={classes.center}>
          <div className={classes.denyTitle}>{texts.adminAccessDeniedTitle}</div>
          <div className={classes.denyText}>
            {texts.adminAccessDeniedBody}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={classes.shell}>
      <Outlet />
    </div>
  );
}